import { render, staticRenderFns } from "./OtherReceivableList.vue?vue&type=template&id=f14e1600&scoped=true&"
import script from "./OtherReceivableList.vue?vue&type=script&lang=js&"
export * from "./OtherReceivableList.vue?vue&type=script&lang=js&"
import style0 from "./OtherReceivableList.vue?vue&type=style&index=0&id=f14e1600&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14e1600",
  null
  
)

export default component.exports